module.exports = __webpack_public_path__ + "static/media/img2.68f40d9d.png";